import React from "react"
import ImageContext from "./image-context"

const CaptionedImage = ({ children, data }) => {
  const {
    alignment = "center",
    margin = 12,
    width = 800,
    wrapText = false
  } = data

  let figureMargin = `${margin}px 0`

  if (wrapText) {
    figureMargin =
      alignment === "left"
        ? `0 ${margin}px ${margin}px 0`
        : `0 0 ${margin}px ${margin}px`
  }

  const figureStyle = {
    display: "block",
    margin: figureMargin,
    maxWidth: `100%`,
    width: `${width}px`
  }

  const tableWidth =
    wrapText && width ? parseInt(width) + parseInt(margin) : "100%"
  const tableAlignment = wrapText ? alignment : undefined

  const wrapStyling =
    "@media (max-width:600px) { table.email-image { float: none; !important; } }"

  return (
    <>
      {wrapText && <style>{wrapStyling}</style>}
      <table
        width={tableWidth}
        border="0"
        cellSpacing="0"
        cellPadding="0"
        style={{ tableLayout: "fixed" }}
        align={tableAlignment}
        className="email-image"
      >
        <tbody>
          <tr>
            <td align={alignment}>
              <figure style={figureStyle}>
                <ImageContext.Provider value={{ width }}>
                  {children}
                </ImageContext.Provider>
              </figure>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

CaptionedImage.defaultProps = {
  alignment: "center",
  borderRadius: 0,
  margin: 0,
  wrapText: false
}

export default CaptionedImage
